import React, { useEffect, useRef, useState } from 'react';
import { Col, Row, Button, Table, Container, Card, Modal, Tooltip, OverlayTrigger, Spinner } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Pagination from 'react-bootstrap/Pagination';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import editIcon from '../../assets/images/icons/icon-edit.svg';
import delIcon from '../../assets/images/icons/icon-delete.svg';
import '../../assets/css/Users/Users.css';
import { toast } from 'react-toastify';
import DeleteCommuterModal from '../Modals/CommuterModals/DeleteCommuterModal';
import DetailCommuterModal from '../Modals/CommuterModals/DetailCommuterModal';
import EditCommuterModal from '../Modals/CommuterModals/EditCommuterModal';
import warningIcon from '../../assets/images/status-icon.svg';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import DataTable from 'react-data-table-component';
import _, { indexOf } from 'lodash';
import { useNavigate } from 'react-router-dom';
import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';
import ProvinceData from '../../constants/ProvinceData';
import { getCities } from '../../helpers/utils';
import { useCSVDownloader } from 'react-papaparse';

const Commuters = () => {
    const navigate = useNavigate();
    const [showDel, setShowDel] = useState(false);
    const [showBulkDel, setShowBulkDel] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [offset, setOffset] = useState(0);
    const [allCommuters, setAllCommuters] = useState([]);
    const [selectedItem, setSelectedItem] = useState();
    const [delId, setDelId] = useState();
    const [showDelModal, setShowDelModal] = useState(false);
    const [activeNumber, setActiveNumber] = useState(1);
    const [paginationBtns, setPaginationBtns] = useState(1);
    const [loading, setLoading] = useState(false);
    const [role, setRole] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [isTypeFilterSelected, setIsTypeFilterSelected] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [province, setProvince] = useState('');
    const [cities, setCities] = useState([]);
    const [city, setCity] = useState('');
    const [showToolTip, setShowToolTip] = useState(false);
    const { getToken, user } = useAuth();
    const { CSVDownloader, Type } = useCSVDownloader();
    const [all_commuters_data, setAllCommutersData] = useState([]);

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => (role === 'agency' ? row?.commuter?.name || 'N/A' : row?.name),
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Email</span>
                </h6>
            ),
            selector: (row) => (role === 'agency' ? row.commuter?.email : row?.email),
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center text-long">
                    <span className="fw-bold">Province/Territory</span>
                </h6>
            ),
            selector: (row) => (role === 'agency' ? row?.commuter?.region || 'N/A' : row?.region || 'N/A'),
            // sortable: true,
            center: true
        },
        // {
        //     name: (
        //         <h6 className="text-capitalize mt-2 text-center">
        //             <span className="fw-bold">City</span>
        //         </h6>
        //     ),
        //     selector: (row) => (role === 'agency' ? row.commuter.city : row.city),
        //     // sortable: true,
        //     center: true
        // },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">
                        Number <span className="text-lowercase">of</span> Trips
                    </span>
                </h6>
            ),
            selector: (row) => (role === 'agency' ? row.noOfTrips : row.tripsCount),
            // sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <select
                    value={row?.status}
                    onChange={(e) => {
                        e.preventDefault();
                        updateSingle(row?._id, { status: e.target.value });
                    }}
                    className={row?.status === 'inactive' ? 'status-selector-inactive' : 'status-selector'}
                    aria-label="Default select example"
                >
                    <option value={'active'}>Active</option>
                    <option value={'inactive'}>Inactive</option>
                </select>
            ),
            center: true
            // sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="d-flex">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="view-detail">
                                <img
                                    key={row?._id}
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    // onMouseOver={() => setShowToolTip(true)}
                                    // onMouseLeave={() => setShowToolTip(false)}
                                    onClick={() => {
                                        setSelectedItem(row);
                                        navigate(`/commuters/commuter-details`, {
                                            state: {
                                                userDetails: row,
                                                user_id: role === 'agency' ? row.commuter._id : row._id
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>

                        {role === 'admin' && (
                            <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Edit</Tooltip>}>
                                <div className="edit-detail">
                                    <img
                                        width={15}
                                        className="me-3"
                                        src={editIcon}
                                        alt=""
                                        onClick={() => {
                                            navigate('/commuters/edit-commuter', {
                                                state: {
                                                    commuterDetails: row,
                                                    commuter_id: role === 'agency' ? row.commuter._id : row._id
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </OverlayTrigger>
                        )}
                        {/* only admin can perform the action */}
                        {role === 'admin' && (
                            <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Delete</Tooltip>}>
                                <div className="del-detail">
                                    <img
                                        width={15}
                                        src={delIcon}
                                        alt=""
                                        onClick={() => {
                                            setDelId(role === 'agency' ? row.commuter._id : row._id);
                                            setShowDelModal(true);
                                        }}
                                    />
                                </div>
                            </OverlayTrigger>
                        )}
                    </div>

                    {/* <div className="view-detail">
                        <img
                            key={row?._id}
                            width={15}
                            className="me-3"
                            src={viewIcon}
                            alt=""
                            // onMouseOver={() => setShowToolTip(true)}
                            // onMouseLeave={() => setShowToolTip(false)}
                            onClick={() => {
                                setSelectedItem(row);
                                navigate(`/commuters/commuter-details`, {
                                    state: {
                                        userDetails: row,
                                        user_id: role === 'agency' ? row.commuter._id : row._id
                                    }
                                });
                            }}
                        />
                        <ToolTip text="View details" target={target} show={showToolTip} />
                    </div> */}
                    {/* <div className="edit-detail">
                        <img
                            width={15}
                            className="me-3"
                            src={editIcon}
                            alt=""
                            onClick={() => {
                                navigate('/commuters/edit-commuter', {
                                    state: {
                                        commuterDetails: row,
                                        commuter_id: role === 'agency' ? row.commuter._id : row._id
                                    }
                                });
                                // setSelectedItem(row);
                                // setShowEditModal(true);
                            }}
                        />
                    </div>
                    <div className="del-detail">
                        <img
                            width={15}
                            src={delIcon}
                            alt=""
                            onClick={() => {
                                setDelId(role === 'agency' ? row.commuter._id : row._id);
                                setShowDelModal(true);
                            }}
                        />
                    </div> */}
                </div>
            ),
            center: true
            // sortable: true
        }
    ];
    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
        // cells: {
        //     style: {
        //         paddingLeft: '8px', // override the cell padding for data cells
        //         paddingRight: '8px'
        //     }
        // }
    };

    useEffect(() => {
        setRole(user.role);
    }, [user]);

    useEffect(() => {
        setOffset((s) => {
            if (activeNumber == 1) {
                return 0;
            } else if (activeNumber == 2) {
                return 10;
            } else if (activeNumber == 3) {
                return 20;
            } else if (activeNumber == 4) {
                return 40;
            } else if (activeNumber == 5) {
                return 50;
            }
        });
    }, [activeNumber]);

    useEffect(() => {
        getPaginatedCommuters();
    }, [offset]);

    const getPaginatedCommuters = async (pageSize = 10, pageNo = 1, _status, _search, region = '', city = '') => {
        const authToken = getToken();
        if (authToken) {
            await new WebApiCalls()
                .getPaginatedCommuters(authToken, pageSize, pageNo, _status, _search, region, city)
                .then((res) => {
                    if (res?.code && res?.code === 200) {
                        setAllCommuters(res.data);
                        setTotalRecords(res?.totalRecords);
                        calcPagination(res?.totalRecords);
                    }
                })
                .catch((error) => {
                    console.log('Error==>   ', error.error);
                });
        }
    };

    const calcPagination = (total) => {
        if (total) {
            const t = (total / 10).toFixed(1);
            if (t > parseInt(t)) {
                setPaginationBtns(parseInt(t) + 1);
            } else {
                setPaginationBtns(parseInt(t));
            }
        } else {
            setPaginationBtns(1);
        }
    };

    const handleClose = () => {
        setShowDel(false);
        setShowDetailModal(false);
        setShowEdit(false);
        setShowDelModal(false);
        setChangeStatusModal(false);
        setShowBulkDel(false);
    };

    const handleDelete = async () => {
        let token = getToken();
        if (delId && token) {
            await new WebApiCalls()
                .deleteCommuter(token, delId)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Commuter has been deleted successfully.');
                        getPaginatedCommuters();
                    }
                })
                .catch((error) => {});
        }
    };

    const handlePageChange = (pageNo) => {
        // fetchUsers(page);
        getPaginatedCommuters(pageSize, pageNo);
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getPaginatedCommuters(pageSize, pageNo);
        setPageSize(pageSize);
        setLoading(false);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const searchDebounce = _.debounce((text = '', region = '', city = '') => {
        getPaginatedCommuters(undefined, undefined, '', text, region, city);
    }, 2000);

    const updateBulk = async (status) => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows,
                status: status
            };
            if (token)
                new WebApiCalls()
                    .updateBulkCommuter(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getPaginatedCommuters();
                            setLoading(false);
                            toast.success('Commuters are Updated Successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const updateSingle = async (selectedId, body) => {
        try {
            setLoading(true);
            const token = getToken();
            if (token)
                new WebApiCalls()
                    .updateCommuter(token, body, selectedId)
                    .then((res) => {
                        if (res?.code === 200) {
                            getPaginatedCommuters();
                            setLoading(false);
                            toast.success('Commuter is updated successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const deleteBulk = async () => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkCommuter(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getPaginatedCommuters();
                            setLoading(false);
                            toast.success(selectedRows.length > 1 ? 'Commuters have been deleted successfully.' : 'Commuter has been deleted successfully');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const getAllCommuters = () => {
        try {
            setLoading(true);
            const token = getToken();
            if (token) {
                new WebApiCalls().getAllCommuters(token).then((res) => {
                    if (res?.code === 200) {
                        setAllCommutersData(res.data);
                        setLoading(false);
                    }
                });
            }
        } catch (error) {
            console.warn('ERROR while fetching all commuters', error);
        }
    };

    useEffect(() => {
        getAllCommuters();
    }, []);

    return (
        <div style={{ padding: '20px' }}>
            <Modal centered show={changeStatusModal} onHide={handleClose} size="md">
                <Modal.Header closeButton onClick={handleClose}>
                    <Modal.Title className="text-center">
                        <h6 className="mt-2 modal-detail">Change Status</h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <div className="icon-warning-wrapper my-1 mt-1">
                        <img src={warningIcon} alt="" />
                    </div>
                    <p className="mx-4 my-4 px-5">Are you sure you want to change status?</p>
                    <div className="text-content-wrapper mt-3">
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#198754' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('active');
                                }}
                            >
                                Active
                            </Button>
                        </div>
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#F32013' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('inactive');
                                }}
                            >
                                Inactive
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 mt-2"></Modal.Footer>
            </Modal>

            <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Commuter?'} />
            <CommonModal
                handleClose={handleClose}
                show={showBulkDel}
                handleDelete={deleteBulk}
                text={selectedRows?.length > 1 ? 'Are you sure, you want to delete selected Commuters?' : 'Are you sure, you want to delete selected Commuter?'}
            />
            <Row className="mb-4 mt-1">
                <Col sm={3} md={3} style={{ paddingRight: 0 }} className="mb-4 mb-sm-0">
                    <input
                        type={'search'}
                        className="search-input-bar"
                        placeholder={'Search here...'}
                        onChange={(e) => {
                            e.preventDefault();
                            searchDebounce(e.target.value);
                        }}
                    />
                </Col>
                <Col sm={4} md={4} style={{ paddingLeft: 0 }} className="mb-4 mb-sm-0">
                    <div className="d-flex gap-10">
                        <div className="d-flex gap-10 justify-content-start">
                            <h6 className="text-capitalize mt-2 text-center">
                                {/* <span className="fw-bold" style={{ whiteSpace: 'nowrap' }}>
                            Filter By
                        </span> */}
                            </h6>
                            {/* <select
                        onChange={(e) => {
                            getAllVendors(undefined, undefined, e.target.value);
                            setIsTypeFilterSelected(e.target.value ? true : false);
                        }}
                        className="status-selector w-120"
                        aria-label="Default select example"
                        style={{ color: !isTypeFilterSelected ? '#9a9a9a' : '' }}
                    >
                        <option value={''}>Transit Type</option>
                        <option value={'bus'}>Bus</option>
                        <option value={'streetcar'}>Street Car</option>
                        <option value={'subway'}>Subway</option>
                        <option value={'train'}>Train</option>
                    </select> */}
                            <select
                                onChange={(e) => {
                                    getPaginatedCommuters(undefined, undefined, e.target.value, '');
                                    setIsFilterSelected(e.target.value ? true : false);
                                }}
                                className="status-selector w-120"
                                aria-label="Default select example"
                                style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                            >
                                <option value={''}>Status</option>
                                <option value={'active'}>Active</option>
                                <option value={'inactive'}>Inactive</option>
                            </select>
                        </div>
                        <div className="d-flex gap-10 justify-content-start">
                            <select
                                className="common-selector w-160"
                                aria-label="Default select example"
                                style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                                onChange={(e) => {
                                    const { value } = e.target;
                                    setProvince(value);
                                    setCities(() => getCities(ProvinceData, value));
                                    searchDebounce('', value);
                                }}
                                name="region"
                                value={province}
                            >
                                <option value={''} hidden disabled>
                                    Province/Territory
                                </option>
                                {ProvinceData.map((province) => (
                                    <option value={province.provinceName}>{province.provinceName}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </Col>
                <Col sm={5} md={5} lg={5}>
                    <div className="d-flex gap-10 justify-content-end h-100">
                        {!buttonDisable && (
                            <>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: '#F3D119', color: 'black' }}
                                    onClick={(e) => {
                                        // updateBulk('active');
                                        setChangeStatusModal(true);
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Change Status
                                    {/* {activeButton} */}
                                </Button>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: 'red' }}
                                    onClick={(e) => {
                                        setShowBulkDel(true);
                                        // deleteBulk();
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Delete
                                </Button>
                            </>
                        )}

                        {all_commuters_data.length !== 0 && (
                            <CSVDownloader
                                type={Type.Button}
                                filename={'all_commuters'}
                                bom={true}
                                data={[...all_commuters_data].map((row) => {
                                    const { _id, created_at, saved_locations, status, ...rest } = row;
                                    return rest;
                                })}
                                className="export-file justify-content-center w-140 align-items-center"
                                style={{ background: '#198754', cursor: 'pointer', color: 'white', borderRadius: '10px', padding: '10px' }}
                            >
                                Export CSV
                            </CSVDownloader>
                        )}
                    </div>
                    {/* </Col> */}
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={allCommuters}
                selectableRows
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={allCommuters && allCommuters?.length >= 0 ? false : true}
                responsive
                direction="auto"
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                subHeaderWrap
                customStyles={customStyles}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                // defaultSortFieldId={1}
            />
        </div>
    );
};
export default Commuters;
